import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "audio",
  "click.stop": ""
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Audioplayer = _resolveComponent("Audioplayer")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      stroke: "#535862",
      icon: "podcast-player",
      width: "3rem",
      height: "3rem"
    }),
    _createVNode(_component_Audioplayer, {
      class: "audioplayer",
      "show-skip": false,
      title: $options.name,
      "show-track": "",
      "volume-change": false,
      file: $options.src,
      details: $options.size
    }, null, 8 /* PROPS */, ["title", "file", "details"])
  ]))
}